(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["so-premium-home"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('change',function(event){if(!event.target.matches('.so-variant-select'))return;const select=event.target;const option=select.selectedOptions[0];const card=select.closest('.so-product-card');if(!option||!option.dataset.price||!card)return;card.querySelector('[data-so-price]').textContent=option.dataset.price;card.querySelector('[data-so-product-link]').href=select.dataset.baseUrl+'?variant='+encodeURIComponent(option.value);});

document.addEventListener('submit',async function(event){
 const form=event.target;
 if(!form.matches('.so-choice-form'))return;
 event.preventDefault();event.stopImmediatePropagation();
 const button=form.querySelector('button[type="submit"]');
 const feedback=form.querySelector('[data-so-feedback]');
 if(button.disabled)return;
 button.disabled=true;form.setAttribute('aria-busy','true');feedback.textContent='';
 try{
  const endpoint=new URL(form.getAttribute('action'),window.location.href);
  const response=await fetch(endpoint.pathname+'.js',{method:'POST',body:new FormData(form),headers:{'Accept':'application/json'}});
  const result=await response.json();
  if(!response.ok)throw new Error(result.description||feedback.dataset.error);
  window.location.assign(endpoint.pathname.replace(/\/add$/,''));
 }catch(error){feedback.textContent=error.message||feedback.dataset.error;button.disabled=false;form.removeAttribute('aria-busy');}
},true);

  } catch(e) { console.error(e); }
})();
})();
